// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./Lessons.module.css";

// CSS
// Models
import { I_SampleExamLesson } from "../../../Models/interfaces";
// Models
// Contexts
import { UserTokenContext } from "../../../Contexts/userToken";
// Contexts
// Utils
import LessonCard from "./LessonCard/LessonCard";
// Utils
// Services
// Services
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import { getLessons_Service } from "../../../Services/Common/getLessons_Service";
import { getSampleLessonsService } from "../../../Services/SampleExams/get/getSampleLessonsService";
import { getCurrentUserDataService } from "../../../Services/Profile/get/getCurrentUserDataService";
// Skeleton

const lessonColors: string[] = [
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
  "invert(58%) sepia(79%) saturate(6067%) hue-rotate(242deg) brightness(100%) contrast(96%)",
  "invert(47%) sepia(94%) saturate(466%) hue-rotate(93deg) brightness(103%) contrast(101%)",
  " invert(52%) sepia(84%) saturate(836%) hue-rotate(180deg) brightness(100%) contrast(93%)",
  " invert(32%) sepia(19%) saturate(6970%) hue-rotate(342deg) brightness(103%) contrast(91%)",
  "invert(29%) sepia(99%) saturate(5458%) hue-rotate(328deg) brightness(94%) contrast(93%)",
  "invert(12%) sepia(40%) saturate(443%) hue-rotate(155deg) brightness(90%) contrast(82%)",
  " invert(48%) sepia(88%) saturate(2023%) hue-rotate(149deg) brightness(102%) contrast(99%)",
  "invert(40%) sepia(97%) saturate(1478%) hue-rotate(1deg) brightness(104%) contrast(103%)",
];

interface LessonsProps {
  setActiveGradeName: React.Dispatch<React.SetStateAction<string>>;
}

const Lessons: React.FC<LessonsProps> = ({ setActiveGradeName }) => {
  const [lessons, setLessons] = useState<I_SampleExamLesson[]>([]);
  const [isPending, setIsPending] = useState<boolean>(true);
  const userToken = useContext(UserTokenContext);

  useEffect(() => {
    if (userToken === "init" || "") return;
    if (!userToken) return;
    getCurrentUserDataService(userToken)
      .then(({ data }) => {
        const g = data?.data?.grade_id ?? data?.grade_id ?? null;
        if (g) {
          setActiveGradeName(
            data?.data?.grade?.title ?? data?.grade?.title ?? "",
          );
        }
      })
      .catch((err) => console.error(err));
    getSampleLessonsService(userToken)
      .then(({ data: { data } }) => {
        setIsPending(false);
        setLessons(data);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        toast(
          err.response.data.message ? err.response.data.message : err.message,
        );
      });
  }, [userToken]);

  return (
    <div
      className={`${
        styles.userLessons
      } flex flex-row flex-wrap items-center justify-start pt-4 ${
        isPending ? styles.pendingSkeleton : ""
      } `}
      style={{ paddingBottom: "6vh", direction: "rtl" }}
    >
      {isPending ? (
        <>
          <SkeletonTheme
            baseColor="rgba(126, 58, 229 , 0.1)"
            highlightColor="rgba(126, 0, 229, 0.6)"
          >
            <p>
              <Skeleton count={9} width={"28vw"} height={"150px"} />
            </p>
          </SkeletonTheme>
        </>
      ) : (
        <>
          {lessons.length ? (
            lessons.map((item, index) => (
              <LessonCard
                imgUrl={item.image.url
                  .replace(/(http[^\s])/i, "https:")
                  .replace("::", ":")}
                name={item.title}
                key={item.id}
                lessonId={item.id}
                lessonData={item}
                filter={lessonColors[index]}
              />
            ))
          ) : (
            <p className="text-gray-500 text-center w-full mt-8">
              هیچ درسی یافت نشد.
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default Lessons;
